import { HEX_HEIGHT_FACTOR } from '~/composables/grid/constants'
import type { GridShapesMenu, Shape } from '~/types/grid.types'

export enum SHAPE_IDS {
  HEX_SPACED = 'HexSpaced',
  SMALL_DIAMOND_SPACED = 'SmallDiamondSpaced',
  SMALL_DIAMOND_60_SPACED = 'SmallDiamond60Spaced',
  SMALL_DIAMOND_120_SPACED = 'SmallDiamond120Spaced',
}

export const SHAPES: Shape[] = [
  {
    type: 'hex',
    id: SHAPE_IDS.HEX_SPACED,
    icon: 'Hex',
    prefix: 'Hex',
    label: 'Hex',
    w: 120,
    h: Math.round(120 * HEX_HEIGHT_FACTOR),
    sides: 6,
    radius: 60,
    rotation: 90, // konva default drawing is different form feltright standard
  },
  {
    type: 'diamond',
    id: SHAPE_IDS.SMALL_DIAMOND_SPACED,
    icon: 'SmallDiamond',
    prefix: 'Diamond',
    label: 'Small Diamond',
    w: 60,
    h: Math.round(120 * HEX_HEIGHT_FACTOR),
  },
  {
    type: 'diamond',
    id: SHAPE_IDS.SMALL_DIAMOND_60_SPACED,
    icon: 'SmallDiamond',
    prefix: 'Diamond',
    label: 'Small Diamond 60',
    w: 60,
    h: Math.round(120 * HEX_HEIGHT_FACTOR),
    rotation: 60,
  },
  {
    type: 'diamond',
    id: SHAPE_IDS.SMALL_DIAMOND_120_SPACED,
    icon: 'SmallDiamond',
    prefix: 'Diamond',
    label: 'Small Diamond 120',
    w: 60,
    h: Math.round(120 * HEX_HEIGHT_FACTOR),
    rotation: 120,
  },
]

export const MENU: GridShapesMenu = {
  list: [
    {
      title: 'Shapes:',
      collapse: false,
      items: [
        ...SHAPES.filter((s: Shape) => [
          'HexSpaced',
          'SmallDiamondSpaced',
          'SmallDiamond60Spaced',
          'SmallDiamond120Spaced',
        ].includes(s.id)),
      ],
    },
  ],
  default: SHAPES.find((s: Shape) => 'HexSpaced' === s.id),
}

export const findShapeById = (id: string): Shape | undefined => {
  // Helper function to search in an array of shapes
  const searchInShapes = (shapes: Shape[]): Shape | undefined => {
    for (const shape of shapes) {
      // Check if current shape matches the ID
      if (shape.id === id) {
        return shape;
      }

      // If this shape has children, search in them too
      if (shape.children?.length) {
        const foundInChildren = searchInShapes(shape.children);
        if (foundInChildren) {
          return foundInChildren;
        }
      }
    }

    return undefined;
  };

  return searchInShapes(SHAPES);
};
